import { extend, override } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import IndexPage from 'flarum/forum/components/IndexPage';
import WelcomeHero from 'flarum/forum/components/WelcomeHero';
import username from 'flarum/common/helpers/username';


extend(HeaderSecondary.prototype, 'items', function(items) {
    const user = app.session.user;

    items.remove('locale');
    items.remove('notifications');
    items.remove('signUp');
    items.remove('session');
    // items.remove('logIn');
    if (app.session.user) {
        items.add('hello', <span>Olá, <strong>{username(user)} &nbsp;&nbsp;</strong></span>);
        items.add('profile', <a href="https://lideres.fundacaolemann.org.br/perfil"><i class="far fa-user"></i> Meu perfil</a>);
        items.add('settings', <a href="/settings">&nbsp;&nbsp;<i class="fas fa-cog"></i> Preferências</a>);
    }
});

override(IndexPage.prototype, 'hero', function(items) {
    const user = app.session.user;
    const clickSobre = () => {
        document.querySelector('#blog-sobre').submit()
    };
    const clickPublicacoes = () => {
        document.querySelector('#blog-publicacoes').submit()
    };

    return (
        <div>
            <div className="SubHeader-IndexPage">
                <ul class="menu-items">
                    <li>
                        <form method="post" action="https://blog.lideres.fundacaolemann.org.br/" id="blog-publicacoes">
                            <input type="hidden" name="token" value="f97f5f1f5e9acb9e039d6dd7a8c2d119"/>
                            <input type="hidden" name="e" value={user.email()}/>
                            <input type="hidden" name="u" value={user.username()}/>
                            <input type="hidden" name="r" value="/lideres-publicacoes/"/>
                            <a href="#" onclick={clickPublicacoes}>Por dentro da Rede</a>
                        </form>
                    </li>
                    <li>
                        <form method="post" action="https://blog.lideres.fundacaolemann.org.br/" id="blog-sobre">
                            <input type="hidden" name="token" value="f97f5f1f5e9acb9e039d6dd7a8c2d119"/>
                            <input type="hidden" name="e" value={user.email()}/>
                            <input type="hidden" name="u" value={user.username()}/>
                            <input type="hidden" name="r" value="/sobre/"/>
                            <a href="#" onclick={clickSobre} ia-current="page">Sobre a Rede</a>
                        </form>
                    </li>
                    <li><a href="/">Fórum de discussão</a></li>
                    <li><a href="http://lideres.fundacaolemann.org.br/membros">Membros</a></li>
                    <li><a href="http://lideres.fundacaolemann.org.br/vagas/">Vagas</a></li>
                    <li><a href="http://lideres.fundacaolemann.org.br/eventos">Webinars</a></li>

                </ul>
            </div>
            {WelcomeHero.component()}
        </div>
    );
});

// We provide our extension code in the form of an "initializer".
// This is a callback that will run after the core has booted.
app.initializers.add('fundacaolamenn-custom', function(app) {
    // Your Extension Code Here

    // console.log("EXTENSION NAME is working!");
});